import {createSlice, Draft, PayloadAction} from '@reduxjs/toolkit';

const initialState: any = {
    data: null,
    zoom: 10,
    defaultReportCenter: null,
    mapCenter: [55.7522, 37.6156],
    inputValues: {
        mapModes: ['Active', 'Paused', 'Vacancy'],
        qualityService: true,
        demand: false,
        combineDays: false,
        period: {id: 'month', name: 'Месяц'},
        days: [
            "MONDAY",
            "TUESDAY",
            "WEDNESDAY",
            "THURSDAY",
            "FRIDAY",
            "SATURDAY",
            "SUNDAY"
        ],
        rating: ['1', '2', '3', '4', '5'],
    }
};

export const mapSlice = createSlice({
                                        name: 'mapList',
                                        initialState,
                                        reducers: {
                                            reducerMapsList: (
                                                state: Draft<any>,
                                                action: PayloadAction<any>
                                            ) => {
                                                state.data = action.payload;

                                                const statusTexts: { [key: string]: string } = {
                                                    Active: 'Обслуживаются',
                                                    Paused: 'Временно неактивна',
                                                    Vacancy: 'Вакансия',
                                                    Available: 'Доступны<br>(действующие сети)',
                                                    AvailableNewChains: 'Доступны<br>(новые сети)',
                                                };

                                                const initialCounter: { [key: string]: { text: string; count: number; status: string } } =
                                                    Object.keys(statusTexts).reduce((acc, key) => {
                                                        acc[key] = {
                                                            text: statusTexts[key],
                                                            count: 0,
                                                            status: key
                                                        };
                                                        return acc;
                                                    }, {} as { [key: string]: { text: string; count: number; status: string } });

                                                const counter = action.payload.reduce(
                                                    (
                                                        acc: { [key: string]: { text: string; count: number; status: string } },
                                                        obj: { status: { [key: string]: string } }
                                                    ) => {
                                                        Object.keys(obj.status).forEach((key) => {
                                                            if (acc[key]) {
                                                                acc[key].count++;
                                                            }
                                                        });
                                                        return acc;
                                                    },
                                                    initialCounter
                                                );

                                                state.counter = Object.values(counter);
                                            },
                                            reducerMapsInputValues: (
                                                state: Draft<any>,
                                                action: PayloadAction<any>
                                            ) => {
                                                state.inputValues = {
                                                    ...state.inputValues,
                                                    ...action.payload
                                                };
                                            },
                                            reducerEditMapCenter: (
                                                state: Draft<any>,
                                                action: PayloadAction<any>
                                            ) => {
                                                state.mapCenter = action.payload;
                                            },
                                            reducerGetReport: (
                                                state: Draft<any>,
                                                action: PayloadAction<any>
                                            ) => {
                                                state.defaultReportCenter = action.payload;
                                            },
                                            reducerClearMapInputValues: () => {
                                                return initialState;
                                            },
                                            reducerTest: (state: Draft<any>, action: PayloadAction<any>) => {
                                                state.inputTest = {...state.inputTest, ...action.payload};
                                            },
                                        },
                                    });

export const {
    reducerTest,
    reducerMapsList,
    reducerGetReport,
    reducerEditMapCenter,
    reducerMapsInputValues,
    reducerClearMapInputValues
} = mapSlice.actions;

export default mapSlice.reducer;